import { z } from "zod";

export const envSchema = z.object({
  VITE_APP_MAPBOX_ACCESS_TOKEN: z
    .string()
    .min(1, "VITE_APP_MAPBOX_ACCESS_TOKEN is required"),
  VITE_API_URL: z.string().min(1, "VITE_API_URL is required"),
});

export type Env = z.infer<typeof envSchema>;

const _env = envSchema.safeParse(import.meta.env);

if (!_env.success) {
  console.error(
    "❌ Invalid environment variables:",
    z.prettifyError(_env.error),
  );
  process.exit(1);
}

export const env: Env = _env.data;
